import React from 'react';
import { Redirect } from 'react-router-dom';
import { Permissions } from '../../../shared/auth/constants/permissions';
import { useHasPermission } from '../../Session';
import BasicLayout from '../../layouts/BasicLayout';
import { MyBids } from '../../pages/DealerBiddings';

const MyBidsRoute = () => {
    const canViewMyOffers = useHasPermission(Permissions.SALES_TRANSACTION_VIEW_MY_OFFERS);

    if (canViewMyOffers) {
        return (
            <BasicLayout>
                <MyBids />
            </BasicLayout>
        );
    }

    return <Redirect to="/403" />;
};

export default MyBidsRoute;
